import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {isImageUrl} from '../../utils/VideoRecapUtils';

export default function VideoRecapScene({
  data,
  selected,
  selectedItemValue,
  clickItem,
  limitReached,
}) {
  const {key, text, eligible, image} = data;
  const style = {backgroundImage: isImageUrl(image) ? `url(${image})` : image};
  return (
    <div
      key={key}
      className={classnames('cvrvItem', {
        grayOut: !eligible || (limitReached && !selected),
        selected,
      })}
      style={style}>
      <div className="cvrvItem-overlay" onClick={clickItem} role="presentation">
        <span
          className={classnames('cvrvItem-overlay-checkbox', {'icon-check': selected})}
          data-number={selectedItemValue && selectedItemValue.number}
        />
        <h3 className="cvrvItem-overlay-text">{text}</h3>
      </div>
    </div>
  );
}

VideoRecapScene.propTypes = {
  data: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  selectedItemValue: PropTypes.object,
  clickItem: PropTypes.func.isRequired,
  limitReached: PropTypes.bool.isRequired,
};
